import io from 'socket.io-client';
import { SOCKET_BASEURL } from './socketConfig';

let socketUrl = null;
let currentUrl = null;

const SOCKET_FAILED = 'SOCKET_FAILED';

const socket = () => {

  // stop reconnect if already failed
  if (localStorage.getItem(SOCKET_FAILED) == 'true') {
    return null;
  }

  const newUrl = SOCKET_BASEURL();

  // Create socket first time OR recreate if URL changed
  if (!socketUrl || newUrl !== currentUrl) {
    if (socketUrl) {
      socketUrl.disconnect();
    }

    currentUrl = newUrl;

    socketUrl = io(newUrl, {
      reconnection: false
    });

    socketUrl.on('connect_error', () => {
      localStorage.setItem(SOCKET_FAILED, 'true');
      socketUrl.disconnect();
      socketUrl = null;
    });
  }

  return socketUrl;
};

export default socket;